/* eslint-disable default-case */
import produce from 'immer';
import { listKeyMetricsUrls, listLookerUrls } from './actions';

const initialState = {
  error: null,
  keyMetric: null,
  lookerUrls: [],
  loading: false,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case listLookerUrls.FAILURE:
    case listKeyMetricsUrls.FAILURE:
      draft.error = payload;
      break;
    case listLookerUrls.TRIGGER:
    case listKeyMetricsUrls.TRIGGER:
      draft.loading = true;
      draft.error = null;
      break;
    case listKeyMetricsUrls.SUCCESS:
      draft.keyMetric = payload;
      break;
    case listLookerUrls.SUCCESS:
      draft.lookerUrls = payload;
      break;
    case listLookerUrls.FULFILL:
    case listKeyMetricsUrls.FULFILL:
      draft.loading = false;
      break;
  }
}, initialState);
export default reducer;
